module.exports = __webpack_public_path__ + "img/form2.b25f0039.png";